import { render, staticRenderFns } from "./ChatMessagesComponent.vue?vue&type=template&id=260d8974&"
import script from "./ChatMessagesComponent.vue?vue&type=script&lang=js&"
export * from "./ChatMessagesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports